











import { Component, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component
export default class extends HsComponent {
  // #region variables
  @Prop({ default: '페이지 타이틀' }) readonly pageTitle!: string | boolean
  @Prop({ default: 'type1' }) readonly headerLayoutType!: string

  readonly headerHeight = 44
  // #endregion
  // #region hooks
  // #endregion
  // #region methods
  back() {
    // 뒤로가기가 없어질 때 사용하기
    if (window.location.pathname.startsWith('/ext/esMain')) {
      this.$ustra.router.replace('/ext/esIndex')
    } else if (window.location.pathname.startsWith('/ext/esDetail')) {
      this.$ustra.router.replace('/ext/esMain?cshwCd=' + this.$route.query.cshwCd.toString())
    } else {
      this.$ustra.router.back()
    }
  }

  // #endregion
  // #region watches
  // #endregion
}
